import React from "react";
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";

import deMessages from "./messages/de";
import enMessages from "./messages/en";
import esMessages from "./messages/es";
import frMessages from "./messages/fr";
import jaMessages from "./messages/ja";
import zhMessages from "./messages/zh";

const allMessages = {
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  zh: zhMessages
};

export default function I18nProvider({ children }) {
  const locale = useSelector(({ i18n }) => i18n.lang);
  // Fallback to 'en' if the locale is not supported
  const currentLocale = allMessages[locale] ? locale : "en";
  const messages = allMessages[currentLocale];

  return (
      <IntlProvider locale={currentLocale} messages={messages}>
        {children}
      </IntlProvider>
  );
}
